(() => {
let activeCode='',freeShipping=false;
function syncShipping(field){
 const drawer=field.closest('cart-drawer');
 if(!drawer||!freeShipping)return;
 const price=drawer.querySelector('.lr-cart-delivery__price');
 if(price)price.textContent=new Intl.NumberFormat('de-DE',{style:'currency',currency:drawer.dataset.currency||'EUR'}).format(0);
 const message=drawer.querySelector('.lr-cart-shipping__message span');
 if(message)message.textContent='Dein Versand geht auf uns!';
 const track=drawer.querySelector('.lr-cart-shipping__track');
 if(track){track.setAttribute('aria-valuenow','100');const fill=track.querySelector('span');if(fill)fill.style.width='100%';}
}

class LrCartDiscount extends HTMLElement {
 connectedCallback() {
  this.input=this.querySelector('input'); this.message=this.querySelector('[data-discount-message]');
  if(activeCode){this.input.value=activeCode;this.lastCode=activeCode;}
  queueMicrotask(()=>{if(this.isConnected)syncShipping(this);});
  this.querySelector('form').addEventListener('submit',e=>{e.preventDefault();clearTimeout(this.timer);this.apply();});
  this.input.addEventListener('input',()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>this.apply(),1000);});
 }
 disconnectedCallback(){clearTimeout(this.timer);}
 async apply() {
  const code=this.input.value.trim();
  if(!code||this.busy||code===this.lastCode)return;
  this.busy=true;this.lastCode=code;this.message.textContent='Code wird geprüft …';
  const button=this.querySelector('button');button.disabled=true;
  const checkout=document.getElementById('CartDrawer-Checkout');if(checkout)checkout.disabled=true;
  try {
   const drawer=this.closest('cart-drawer');
   const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/update.js',{
    method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({discount:code,sections:drawer.getSectionsToRender().map(s=>s.id),sections_url:window.location.pathname})
   });
   const cart=await response.json();
   if(!response.ok)throw Error('discount');
   const codes=cart.discount_codes;
   const applicable=Array.isArray(codes)?codes.some(d=>d.code.toLowerCase()===code.toLowerCase()&&d.applicable):null;
   const applications=[...(cart.cart_level_discount_applications||[]),...(cart.items||[]).flatMap(i=>i.line_level_discount_allocations||[]).map(d=>d.discount_application)];
   const shown=applications.some(d=>d?.title?.toLowerCase()===code.toLowerCase());
   if(!cart.sections||drawer.getSectionsToRender().some(s=>!cart.sections[s.id]))throw Error('sections');
   activeCode=code;
   freeShipping=code.toLowerCase()==='free' && applicable!==false;
   drawer.renderContents(cart);
   const next=drawer.querySelector('lr-cart-discount');
   next.input.value=code;next.lastCode=code;
   next.message.textContent=applicable===true||shown?'Rabattcode angewendet.':applicable===false?'Dieser Code ist für deinen Warenkorb nicht gültig.':'Code hinterlegt. Die Gültigkeit wird spätestens an der Kasse geprüft.';
   if(freeShipping)next.message.textContent='';
   next.input.setAttribute('aria-invalid',applicable===false?'true':'false');
   syncShipping(next);
  } catch(error) {
   this.lastCode=null;this.message.textContent='Der Code konnte nicht geprüft werden. Bitte versuche es erneut.';
  } finally {
   this.busy=false;button.disabled=false;
   if(checkout?.isConnected)checkout.disabled=false;
   if(this.isConnected&&this.input.value.trim()!==code)this.apply();
  }
 }
}
if(!customElements.get('lr-cart-discount'))customElements.define('lr-cart-discount',LrCartDiscount);
})();